import React, { Component } from "react";
import { GET, POST, loading, mode, setDarkMode, params, StatusTnx } from "../components/CustomComponent.js";
import { loadPrimerloSdk as loadSdk } from "../components/primerloWidget.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

// หน้า pay ของ Primerlo (ขาซื้อ / Thai QR)
// ลูกค้ามาถึงหน้านี้จากการสแกน QR ที่ ApiPartner สร้าง (QR = ลิงก์หน้านี้ + token) ท่าเดียวกับ Web Topup ของ xtc
// URL: /pay/primerlo?t=<token>
//
// ลำดับ: GET state -> POST session -> mode kyc (widget ยืนยันตัวตน) หรือ buy (widget แสดง Thai QR)
//   widget ปิด (closed done) ของ kyc -> ขอ session อีกรอบจะได้ buy
//   widget ปิด (closed done) ของ buy  -> บาทเข้าแล้ว poll สถานะจนรายการ success แล้วพากลับ return_url
// origin ของหน้านี้ต้องถูกลงทะเบียนกับ Primerlo (SDK โหลดผ่าน components/primerloWidget.js)

const POLL_MS = 5000;
const FINAL_STATUSES = ["success", "cancel", "mismatch", "refund", "fail", "failed", "expired"];

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("th-TH", { hour12: false });
};

export default class PayPrimerlo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: params("t") || "",
      // loading | invalid | expired | kyc | pay | waiting | success | failed | error
      view: "loading",
      transaction: null,
      session: null,
      error_message: "",
      error_code: "",
      paid: false,
      requesting: false,
    };
    this.widget = null;
    this.pollTimer = null;
  }

  async componentDidMount() {
    if (mode === "dark") setDarkMode();
    await this.Start();
  }

  componentDidUpdate() {
    if (mode === "dark") setDarkMode();
  }

  componentWillUnmount() {
    this.StopPolling();
    this.DestroyWidget();
  }

  // ---------- API ----------

  GetState = async () => {
    const { token } = this.state;
    if (!token) return null;
    const result = await GET("callback/primerlo/pay", { t: token });
    return result?.status && result.data ? result.data : null;
  };

  Start = async () => {
    loading(true);
    const transaction = await this.GetState();
    loading(false);

    if (!transaction) {
      this.setState({ view: "invalid" });
      return;
    }

    this.setState({ transaction });

    if (transaction.status === "success") return this.setState({ view: "success" });
    if (FINAL_STATUSES.includes(transaction.status)) return this.setState({ view: "failed" });
    if (transaction.is_expired) return this.setState({ view: "expired" });

    await this.RequestSession();
  };

  // ขอ widgetUrl จาก Backend (Backend เป็นคนตัดสินว่าต้อง kyc ก่อน หรือเปิด buy ได้เลย)
  RequestSession = async () => {
    const { token, requesting } = this.state;
    if (requesting) return;

    this.setState({ requesting: true, error_message: "", error_code: "" });
    loading(true);
    const result = await POST("callback/primerlo/pay/session", { t: token });
    loading(false);
    this.setState({ requesting: false });

    if (!result?.status) {
      // Backend ยัด code ไว้ใน data (kyc_required / amount_out_of_range / destination_* / dependency_unavailable)
      this.setState({
        view: "error",
        error_message: result?.message || "ไม่สามารถเริ่มรายการได้ กรุณาลองใหม่",
        error_code: result?.data?.code || "",
      });
      return;
    }

    const data = result.data || {};
    const { mode: nextMode, widget_url, session_id, ...transaction } = data;
    this.setState({ transaction: { ...this.state.transaction, ...transaction }, session: { id: session_id, mode: nextMode } });

    if (nextMode === "kyc" || nextMode === "buy") {
      if (!widget_url) {
        this.setState({ view: "error", error_message: "ไม่ได้รับลิงก์ widget จากผู้ให้บริการ" });
        return;
      }
      this.setState({ view: nextMode }, () => this.MountWidget(widget_url));
      return;
    }

    if (nextMode === "status") {
      // session เดิมเปิดไปแล้ว (QR แสดงไปแล้ว) เปิดซ้ำไม่ได้ รอผลจาก webhook
      this.setState({ view: "waiting" });
      this.StartPolling();
      return;
    }

    this.setState({ view: "expired" });
  };

  // ---------- widget ----------

  MountWidget = async (url) => {
    this.DestroyWidget();
    try {
      const DealerWidget = await loadSdk();
      this.widget = DealerWidget.mount({
        url: url,
        container: "#primerlo-widget",
        onEvent: this.OnWidgetEvent,
      });
    } catch (err) {
      console.error("mount primerlo widget failed:", err?.message || err);
      this.setState({ view: "error", error_message: "โหลดหน้าชำระเงินไม่สำเร็จ กรุณาลองใหม่" });
    }
  };

  DestroyWidget = () => {
    try {
      if (this.widget?.destroy) this.widget.destroy();
    } catch (e) {}
    this.widget = null;
  };

  // event ชุดเดียวกับ webhook (เอกสาร §12) ส่งมาทาง postMessage จาก origin ของ widget เท่านั้น (SDK กรองให้)
  OnWidgetEvent = async (m) => {
    if (!m || m.type !== "dealer.widget") return;
    const { view } = this.state;

    switch (m.event) {
      case "trade.paid":
        this.setState({ paid: true });
        break;

      case "popup_required": {
        // browser ไม่ให้ทำ passkey/LINE ใน iframe (เฉพาะ session kyc) ต้องเปิดเป็น popup
        // widgetUrl เปิดได้ครั้งเดียว ขอ session ใหม่แล้วเปิดด้วย DealerWidget.open แทน
        this.DestroyWidget();
        const { token } = this.state;
        loading(true);
        const result = await POST("callback/primerlo/pay/session", { t: token });
        loading(false);
        if (result?.status && result.data?.widget_url && window.DealerWidget?.open) {
          this.widget = window.DealerWidget.open({ url: result.data.widget_url, onEvent: this.OnWidgetEvent });
        } else {
          this.setState({ view: "error", error_message: "เบราว์เซอร์นี้ไม่รองรับการยืนยันตัวตนในหน้านี้ กรุณาเปิดด้วย Chrome หรือ Safari" });
        }
        break;
      }

      case "error":
        this.setState({ view: "error", error_message: m.data?.message || "ไม่สามารถดำเนินการต่อได้", error_code: m.data?.code || "" });
        break;

      case "closed": {
        this.DestroyWidget();
        const reason = m.data?.reason;

        if (view === "kyc") {
          // ยืนยันตัวตนเสร็จ (หรือเพิ่มบัญชีธนาคารเสร็จ) ขอ session อีกรอบ Backend จะเปิด buy ให้
          if (reason === "done") return this.RequestSession();
          this.setState({ view: "error", error_message: "การยืนยันตัวตนยังไม่เสร็จ กดลองใหม่เพื่อทำต่อ" });
          return;
        }

        if (view === "pay") {
          if (reason === "done") {
            // บาทเข้าแล้ว รอ USDT ถึง wallet แล้ว Backend ปิดรายการ
            this.setState({ view: "waiting", paid: true });
            this.StartPolling();
            return;
          }
          // cancelled / expired: ลูกค้ากดยกเลิก หรือสร้างรายการไม่ได้ อ่านสถานะล่าสุดก่อนตัดสิน
          this.setState({ view: "waiting" });
          this.StartPolling();
        }
        break;
      }

      default:
        break;
    }
  };

  // ---------- polling ----------

  StartPolling = () => {
    this.StopPolling();
    this.Poll();
    this.pollTimer = setInterval(this.Poll, POLL_MS);
  };

  StopPolling = () => {
    if (this.pollTimer) clearInterval(this.pollTimer);
    this.pollTimer = null;
  };

  Poll = async () => {
    const transaction = await this.GetState();
    if (!transaction) return;
    this.setState({ transaction });

    if (transaction.status === "success") {
      this.StopPolling();
      this.setState({ view: "success" });
      return;
    }
    if (FINAL_STATUSES.includes(transaction.status)) {
      this.StopPolling();
      this.setState({ view: "failed" });
      return;
    }
    // ยังค้างและยังไม่มี trade เกิด = ลูกค้ายกเลิกตอนเปิด widget หรือสร้างรายการไม่ได้ ให้เริ่มใหม่ได้ถ้าลิงก์ยังไม่หมดอายุ
    if (transaction.is_expired) {
      this.StopPolling();
      this.setState({ view: "expired" });
    }
  };

  // ---------- render ----------

  renderRow = (label, value) => (
    <div className="d-flex justify-content-between border-bottom py-2">
      <small className="text-secondary me-3">{label}</small>
      <small className="text-end fw-semibold" style={{ wordBreak: "break-all" }}>
        {value === null || value === undefined || value === "" ? "-" : value}
      </small>
    </div>
  );

  renderSummary = () => {
    const { transaction } = this.state;
    if (!transaction) return null;
    return (
      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fw-bold">{transaction.broker?.name_th || transaction.broker?.name_en || "รายการชำระเงิน"}</span>
            {StatusTnx(transaction.status)}
          </div>
          {this.renderRow("เลขที่รายการ", transaction.ref_no)}
          {this.renderRow("ยอดชำระ", `${transaction.amount} ${transaction.currency}`)}
          {this.renderRow("หมดอายุ", formatDateTime(transaction.expired_at))}
        </div>
      </div>
    );
  };

  renderBody = () => {
    const { view, transaction, error_message, error_code, paid } = this.state;
    const returnUrl = transaction?.return_url;
    const canRetry = transaction && transaction.status === "pending" && !transaction.is_expired;

    switch (view) {
      case "loading":
        return null;

      case "invalid":
        return <div className="alert alert-warning">ลิงก์ไม่ถูกต้องหรือไม่พบรายการ กรุณาสร้างรายการใหม่จากร้านค้าแล้วสแกน QR อีกครั้ง</div>;

      case "expired":
        return (
          <div>
            <div className="alert alert-danger">ลิงก์ชำระเงินนี้หมดอายุแล้ว กรุณาสร้างรายการใหม่จากร้านค้า</div>
            {returnUrl && (
              <a className="btn btn-outline-secondary w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );

      case "kyc":
      case "pay":
        return (
          <div>
            {view === "kyc" ? (
              <div className="alert alert-info py-2">
                <small>
                  การซื้อครั้งแรกต้องยืนยันตัวตนกับ Primerlo ก่อน (เข้าสู่ระบบด้วย Passkey หรือ LINE และยืนยันตัวตน) เมื่อเสร็จแล้วระบบจะแสดง QR
                  สำหรับชำระเงินให้อัตโนมัติ
                </small>
              </div>
            ) : (
              <div className="alert alert-info py-2">
                <small>
                  สแกน Thai QR ด้านล่างด้วยแอปธนาคารของคุณ ยอดและราคาถูกล็อกไว้แล้ว ชำระภายในเวลาที่นับถอยหลัง
                  <br />
                  หากเปิดหน้านี้บนมือถือ ให้บันทึกรูป QR แล้วเปิดแอปธนาคารเพื่อสแกนจากรูปภาพ
                </small>
              </div>
            )}
            <div id="primerlo-widget" className="w-100 mb-3" />
          </div>
        );

      case "waiting":
        return (
          <div>
            <div className="alert alert-success py-2">
              <small>
                {paid
                  ? "ได้รับการชำระเงินแล้ว กำลังรอระบบยืนยันรายการ กรุณาอย่าปิดหน้านี้"
                  : "กำลังตรวจสอบสถานะรายการ กรุณารอสักครู่"}
              </small>
            </div>
            <div className="d-flex justify-content-center my-4">
              <div className="spinner-border text-warning" role="status" />
            </div>
            {canRetry && !paid && (
              <button type="button" className="btn btn-outline-secondary w-100" onClick={this.RequestSession}>
                เริ่มชำระเงินใหม่
              </button>
            )}
          </div>
        );

      case "success":
        return (
          <div>
            <div className="alert alert-success">ชำระเงินสำเร็จ รายการของคุณเสร็จสมบูรณ์แล้ว</div>
            {returnUrl && (
              <a className="btn btn-success w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );

      case "failed":
        return (
          <div>
            {transaction?.status === "mismatch" ? (
              // Primerlo พักรายการ (trade.held sender_mismatch) บัญชีที่โอนไม่ตรงกับผู้ยืนยันตัวตน
              <div className="alert alert-warning">บัญชีที่โอนเงินไม่ตรงกับผู้ทำรายการ รายการถูกพักไว้ให้เจ้าหน้าที่ตรวจสอบ กรุณาติดต่อร้านค้า</div>
            ) : (
              <div className="alert alert-danger">
                รายการไม่สำเร็จ ({transaction?.status}) {transaction?.status_reason ? `: ${transaction.status_reason}` : ""}
              </div>
            )}
            {returnUrl && (
              <a className="btn btn-outline-secondary w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );

      case "error":
      default:
        return (
          <div>
            <div className="alert alert-danger">
              {error_message}
              {error_code ? <small className="d-block text-secondary mt-1">รหัส: {error_code}</small> : null}
            </div>
            {canRetry && (
              <button type="button" className="btn btn-warning w-100 mb-2" onClick={this.RequestSession}>
                ลองใหม่
              </button>
            )}
            {returnUrl && (
              <a className="btn btn-outline-secondary w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );
    }
  };

  render() {
    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}>
            <img alt="logo" src={LOGO} className="w-75" style={{ minWidth: 350 }} />
          </div>
          <div className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}>
            <img alt="logo" src={LOGO} style={{ width: "60%", minWidth: 400 }} />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <div className="d-flex align-items-center mb-2">
                <h3 className="fw-bold text-dark mb-0 me-2">ชำระเงินด้วย Thai QR</h3>
              </div>
              <div className="mb-3">
                <small>ชำระเงินผ่าน Primerlo ยอดเงินจะเข้าสู่ร้านค้าหลังระบบยืนยันรายการ</small>
              </div>

              {this.renderSummary()}
              {this.renderBody()}

              <div className="w-100 text-center mt-3">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
